import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 0.65rem;
    z-index: 1;
    padding: 1.15rem 1.35rem 1.25rem;
    width: min(28rem, calc(100vw - 2rem));
    font-family: 'Inter', sans-serif;
    box-sizing: border-box;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`

export const HeaderText = styled.h2`
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.25;
    margin-top: 0;
    margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.35rem;
    cursor: pointer;
    width: 1.85rem;
    height: 1.85rem;
    flex-shrink: 0;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.65rem;
    height: 0.65rem;
`

export const InputDiv = styled.div`
    display:flex;
    flex-direction: column;
    gap: 0.3rem;
    margin-top: 0.85rem;
`

export const LabelCreate = styled.label`
    font-weight: 600;
    font-size: 0.78rem;
    color: #333;
`

export const InputProfileName = styled.input`
    width: 100%;
    box-sizing: border-box;
    height: 2.35rem;
    min-height: 2.35rem;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 1.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    font-size: 0.84rem;
    color: #333;

    :focus {
        outline: 0;
    }

    ::placeholder {
        color: #888;
        font-size: 0.82rem;
    }
`
export const ButtonsDiv = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.85rem;
`

export const CreateButtonDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    min-height: 2.35rem;
    height: auto;
    padding: 0.5rem 0.95rem;
    background-color: #0090D3;
    color: #fff;
    border-radius: 1.5rem;
    cursor: pointer;
`

export const CreateButtonImage = styled.img`
    width: 0.7rem;
    height: 0.7rem;
    flex-shrink: 0;
`

export const CreateButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 0.8rem;
    font-weight: 700;
    margin: 0;
    margin-left: 0.35rem;
`

export const ErrorMessage = styled.p`
    font-size: .75rem;
    color:red;
    font-weight: 300;
`

export const TipText = styled.p`
    font-family: 'Inter', sans-serif;
    color:red;
    font-weight: 300;
    font-size: 0.72rem;
    margin: 0;
    margin-right: auto;
    flex: 1 1 auto;
    min-width: 0;
`